import { useSelector } from 'react-redux';

export const useIsNewLayout = () => {
    const isNewLayout = useSelector((store) => store.layout.isNewLayout);
    
    return isNewLayout;
};
